import { Action } from '@ngrx/store';
import { Favorite } from 'src/app/models/favorite';

export const FavoriteAction = {
    createFavorite: '[favorite] create favorite',
    deleteFavorite: '[favorite] delete favorite',
    forceFavoriteRefresh: '[favorite] refresh on next pull',
    setFavorites: '[favorite] set favorites',
    updateFavorite: '[favorite] update favorite',
};

export class CreateFavorite implements Action {
    type = FavoriteAction.createFavorite;
    constructor(public favorite: Favorite) {}
}

export class DeleteFavorite implements Action {
    type = FavoriteAction.deleteFavorite;
    constructor(public favoriteId: string) {}
}

export class ForceFavoriteRefresh implements Action {
    type = FavoriteAction.forceFavoriteRefresh;
    constructor(public forceRefresh: boolean) {}
}

export class SetFavorites implements Action {
    type = FavoriteAction.setFavorites;
    constructor(public favorites: Favorite[]) {}
}

export class UpdateFavorite implements Action {
    type = FavoriteAction.updateFavorite;
    constructor(public favorite: Favorite) {}
}
